import { FETCH_CURRENT_USER, LOG_IN_USER, RESET_PAGES_STATE_PARAMS, USER_LOGGING } from './types'
import { userService } from '../../server'
import { ReactSession } from 'react-client-session'

export const logOut = () => async (dispatch) => {
  ReactSession.setStoreType('localStorage')
  ReactSession.set('passwd', null)

  dispatch({ type: RESET_PAGES_STATE_PARAMS })

  return dispatch({
    type: FETCH_CURRENT_USER,
    payload: {
      user: null,
    },
  })
}

export const fetchCurrentUser = () => async (dispatch) => {
  try {
    ReactSession.setStoreType('localStorage')
    const login = ReactSession.get('login')
    const passwd = ReactSession.get('passwd')
    dispatch({ type: USER_LOGGING })
    if (!login) {
      dispatch({
        type: FETCH_CURRENT_USER,
        payload: {
          user: null,
          error: null,
        },
      })
      return
    }
    let user = await userService.login(login, passwd)
    dispatch({
      type: FETCH_CURRENT_USER,
      payload: {
        user: user,
        error: null,
      },
    })
  } catch (error) {
    dispatch({
      type: FETCH_CURRENT_USER,
      payload: {
        user: null,
        error: error.message,
      },
    })
  }
}

export const logIn = (login, passwd) => async (dispatch) => {
  dispatch({ type: USER_LOGGING })
  try {
    let user = await userService.login(login, passwd)
    if (user) {
      ReactSession.setStoreType('localStorage')
      ReactSession.set('login', login)
      ReactSession.set('passwd', passwd)

      dispatch({
        type: LOG_IN_USER,
        payload: {
          user: user,
          error: null,
          isFirstLogin: false,
        },
      })
    } else {
      dispatch({
        type: LOG_IN_USER,
        payload: {
          user: null,
          error: 'Votre login et mot de passe ne correspondent pas.',
          isFirstLogin: false,
        },
      })
    }
  } catch (error) {
    dispatch({
      type: LOG_IN_USER,
      payload: {
        user: null,
        error: error.message,
      },
    })
  }
}
